<!-- Header -->

<div class="card-header card-header-grid">
  <!-- Search -->
  <div class="input-group input-lined" role="search">
    <div class="input-group-text">
      <i role="img" class="fa fa-search text-muted" aria-hidden="true"></i>
    </div>
    <input
      class="form-control"
      type="search"
      placeholder="{{ 'general.search' | translate }}"
      attr.aria-label="{{ 'general.search' | translate }}"
      [(ngModel)]="filterTerm"
      (ngModelChange)="onSearch($event)"
    />
  </div>
  <!-- End Search -->

  <div class="d-flex justify-content-end align-items-center">
    <span *ngIf="!showPageFooter">
      {{ (tableData | recursiveFilter: filterTerm)?.length }}
      <span class="ms-2">{{ 'general.total' | translate }}</span>
    </span>
    <span *ngIf="showPageFooter">
      <total-table-counter
        *ngIf="showTotal"
        [page]="activePage ?? 0"
        [limit]="limitPage"
        [total]="total ?? 0"
      ></total-table-counter>
      <span *ngIf="!showTotal">
        {{ (tableData | recursiveFilter: filterTerm)?.length }}
        <span class="ms-2">{{ 'general.total' | translate }}</span>
      </span>
    </span>

    <div
      class="btn-group ms-3"
      dropdown
      *ngIf="bulkActions?.length"
      [canSee]="[accessRights.Raffle_delete]"
    >
      <button
        class="btn btn-sm btn-white dropdown-toggle"
        type="button"
        aria-controls="bulkAction9"
        dropdownToggle
      >
        {{ 'general.bulkActions' | translate }}
      </button>

      <ul
        *dropdownMenu
        class="dropdown-menu dropdown-menu-right"
        role="menu"
        id="bulkAction9"
      >
        <li *ngFor="let bulkAction of bulkActions">
          <a
            href="javascript:;"
            class="dropdown-item"
            (click)="onClickBulkAction(bulkAction)"
          >
            {{ 'general.' + bulkAction | translate }}
          </a>
        </li>
      </ul>
    </div>
  </div>

  <!-- End Row -->
</div>
<!-- End Header -->

<!-- Table -->
<div class="table-responsive">
  <table
    class="table table-borderless table-striped table-hover table-nowrap"
    [mfData]="
      showPageFooter ? tableData : (tableData | recursiveFilter: filterTerm)
    "
    #dataTable="mfDataTable"
    [mfRowsOnPage]="showPageFooter ? limitPage : 25"
  >
    <thead class="table-light">
      <tr>
        <th
          scope="col"
          (click)="onToggleAllChecked()"
          class="cursor-pointer"
          style="max-width: 60px"
        >
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="allCheckedToggle"
            attr.aria-label="{{ 'general.selectAll' | translate }}"
          />
        </th>
        <th scope="col" style="width: 25%">
          <mfDefaultSorter
            by="registrationStartDate"
            (click)="onSortfieldClick('registrationStartDate')"
          >
            {{ 'raffleModule.registrationStartDate' | translate }}

            <i
              class="fa ms-1"
              role="img"
              [ngClass]="{
                'fa-sort-down': sortingField == 'registrationStartDate_asc',
                'fa-sort-up ': sortingField == 'registrationStartDate_desc',
                'fa-sort text-muted  opacity-50':
                  sortingField !== 'registrationStartDate_asc' &&
                  sortingField !== 'registrationStartDate_desc'
              }"
              attr.aria-label="{{ 'wcag.sort' | translate }}"
            >
            </i>
          </mfDefaultSorter>
        </th>
        <th scope="col" style="width: 25%">
          <mfDefaultSorter
            by="registrationEndDate"
            (click)="onSortfieldClick('registrationEndDate')"
          >
            {{ 'raffleModule.registrationEndDate' | translate }}

            <i
              class="fa ms-1"
              role="img"
              [ngClass]="{
                'fa-sort-down': sortingField == 'registrationEndDate_asc',
                'fa-sort-up ': sortingField == 'registrationEndDate_desc',
                'fa-sort text-muted  opacity-50':
                  sortingField !== 'registrationEndDate_asc' &&
                  sortingField !== 'registrationEndDate_desc'
              }"
              attr.aria-label="{{ 'wcag.sort' | translate }}"
            >
            </i>
          </mfDefaultSorter>
        </th>
        <th scope="col" style="width: 20%">
          <mfDefaultSorter by="drawDate" (click)="onSortfieldClick('drawDate')">
            {{ 'raffleModule.drawDate' | translate }}

            <i
              class="fa ms-1"
              role="img"
              [ngClass]="{
                'fa-sort-down': sortingField == 'drawDate_asc',
                'fa-sort-up ': sortingField == 'drawDate_desc',
                'fa-sort text-muted  opacity-50':
                  sortingField !== 'drawDate_asc' &&
                  sortingField !== 'drawDate_desc'
              }"
              attr.aria-label="{{ 'wcag.sort' | translate }}"
            >
            </i>
          </mfDefaultSorter>
        </th>
        <th scope="col" style="width: 20%">
          <mfDefaultSorter
            by="closeDate"
            (click)="onSortfieldClick('closeDate')"
          >
            {{ 'raffleModule.closeDate' | translate }}

            <i
              class="fa ms-1"
              role="img"
              [ngClass]="{
                'fa-sort-down ': sortingField == 'closeDate_asc',
                'fa-sort-up ': sortingField == 'closeDate_desc',
                'fa-sort text-muted  opacity-50':
                  sortingField !== 'closeDate_asc' &&
                  sortingField !== 'closeDate_desc'
              }"
              attr.aria-label="{{ 'wcag.sort' | translate }}"
            >
            </i>
          </mfDefaultSorter>
        </th>
        <th scope="col" style="width: 35%">
          <mfDefaultSorter by="courseId" (click)="onSortfieldClick('courseId')">
            {{ 'raffleModule.course' | translate }}

            <i
              class="fa ms-1"
              role="img"
              [ngClass]="{
                'fa-sort-down ': sortingField == 'courseId_asc',
                'fa-sort-up ': sortingField == 'courseId_desc',
                'fa-sort text-muted  opacity-50':
                  sortingField !== 'courseId_asc' &&
                  sortingField !== 'courseId_desc'
              }"
              attr.aria-label="{{ 'wcag.sort' | translate }}"
            >
            </i>
          </mfDefaultSorter>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="
          let item of dataTable.data
            | sortData
              : key
              : sortOrder
              : { table: 'raffle', entities: (courseEntities$ | async) };
          let i = index
        "
        class="cursor-pointer"
      >
        <td (click)="onCheckRow(item)" class="cursor-pointer">
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="this.checkedIds.get(item.id)"
            attr.aria-label="{{ 'wcag.selectThis' | translate }}"
          />
        </td>
        <td
          (click)="onRowClicked(item)"
          tabindex="0"
          (keyup.enter)="onRowClicked(item)"
          role="link"
        >
          {{
            item.registrationStartDate
              | date: 'd MMMM yyyy' : null : (selectedLanguage$ | async)
          }}
        </td>
        <td (click)="onRowClicked(item)">
          {{
            item.registrationEndDate
              | date: 'd MMMM yyyy' : null : (selectedLanguage$ | async)
          }}
        </td>
        <td (click)="onRowClicked(item)">
          {{
            item.drawDate
              | date: 'd MMMM yyyy' : null : (selectedLanguage$ | async)
          }}
        </td>
        <td (click)="onRowClicked(item)">
          {{
            item.closeDate
              | date: 'd MMMM yyyy' : null : (selectedLanguage$ | async)
          }}
        </td>
        <td (click)="onRowClicked(item)">
          {{ getCourseDescription(courseEntities$ | async, item) }}
        </td>
        <!-- <td (click)="onRowClicked(item)" >
          <i role="img" class="fa fa-eye text-muted"></i>
      </td> -->
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td *ngIf="showPageFooter" colspan="10" class="pb-0">
          <table-footer
            class=""
            #footer
            [activePage]="activePage - 1"
            [limitOnPage]="limitPage"
            [totalPages]="pageCount"
            (selectedPage)="selectPage($event)"
            (outNewSearch)="setNewSearch($event)"
            (searchLimit)="setSearchLimit($event)"
          >
          </table-footer>
        </td>

        <td *ngIf="!showPageFooter" colspan="6" class="pb-0">
          <mfBootstrapPaginator
            [rowsOnPageSet]="[25, 50, 100]"
          ></mfBootstrapPaginator>
        </td>
      </tr>
    </tfoot>
  </table>
</div>
